<template>
    <div class="togetherOrder">
        <!-- 头部 -->
        <headers :title="'发起一起购'"/>
        <!-- 地址栏 -->
          <div class="addressOut">
                 <div class="addressContent">
                     <div class="namePhone">
                         <div class="name">{{Address.guestName}}</div>
                         <div class="phone">{{Address.guestPhone}}</div>
                         <div class="acreage" v-if="Address.Acreage">{{Address.Acreage}}㎡</div>
                     </div>
                     <div class="address">
                        {{Address.guestAddress}}
                     </div>
                 </div>
                 <div class="addressRight">
                     <span class="iconfont iconyoujiantou"></span>
                 </div>
          </div>
        <!-- 服务内容 -->
        <div class="content">
            <div class="contentLeft">
                <img src="http://www.lungchuenjz.cn/Upload/Common/20181024/1b5e6e8e-5ab2-4585-810a-c4c46e7811df.jpg" alt="">
            </div>
            <div class="contentRight">
                <p style="line-height: 24px;font-size: 14px;">除螨服务（2人团）</p>
                <p style="color: #999999;line-height: 20px;font-size: 12px;padding: 2px 0;overflow:hidden;text-overflow:ellipsis;height: 42px;">仅限虎门和长安地区1.8米以下床垫使用，同一地址只能享受一次优惠，一次使用，有效期60天。</p>
                <p style="line-height: 18px;font-size: 14px;color: #df006e;text-decoration:line-through;">原价：￥168元</p>
                <p style="line-height: 18px;font-size: 14px;color: #df006e;">一起购价：￥116元</p>
            </div>
        </div>
        <!-- 脚步 -->
        <div class="footer">
            <div class="footerLeft">
                一起购价：<span style="color: #df006e;">￥116元</span>
            </div>
            <div class="footerRight">
                发起一起购
            </div>
        </div>

    </div>
</template>

<script>
export default {
    data(){
        return{
            Address:{guestName:'肯',guestPhone:13000000,Acreage:105,guestAddress:'广东省东莞市虎门镇龙泉国际大酒店7楼'}
        }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.togetherOrder
  width 100%
  .addressOut
    width: 100%
    height: 80px
    margin-top: 45px
    background: #f7f4e4
    position: relative
    display: flex
    justify-content: center
    align-items: center
    font-size: 14px
    color: #6b6b6b
    &::before
     content:''
     position:absolute
     top:0
     width:100%
     height:4px
     background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAKBAMAAACOO0tGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURf///4u16Oxtbezz/J3B7NDh9vvd3fSmprjS8vGNje57e/jDw/7w8IQ3dnAAAABSSURBVCjPY2CAAG4l7GADVJ4hUBArEIXJJ2HXrw6TZ8auX7ABKs+zCLsBE2AGmGDXLwKT58SuX+sATIEjdgOcYfJF2A1Qg8lz4PCBwWgQUiMIAWCaOFG2MdFRAAAAAElFTkSuQmCC")   
    &::after
     content:''
     position:absolute
     bottom:0
     width:100%
     height:4px
     background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAKBAMAAACOO0tGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURf///4u16Oxtbezz/J3B7NDh9vvd3fSmprjS8vGNje57e/jDw/7w8IQ3dnAAAABSSURBVCjPY2CAAG4l7GADVJ4hUBArEIXJJ2HXrw6TZ8auX7ABKs+zCLsBE2AGmGDXLwKT58SuX+sATIEjdgOcYfJF2A1Qg8lz4PCBwWgQUiMIAWCaOFG2MdFRAAAAAElFTkSuQmCC")
    .addressContent
      height: 100%
      width: 90%
      margin-left: -2px
      display: flex
      flex-direction: column
      justify-content: center
      padding: 5px
      .namePhone
        display: flex
        margin-bottom: 12px
        .name
          margin-right: 12px
        .phone
          margin-right: 64px
    .addressRight
      &>span
        font-size: 28px
  .content
    width 100%
    box-sizing border-box
    padding 8px
    display flex
    align-items center
    margin-top 10px
    border-bottom: 1px solid #f0f0f0;
    .contentLeft
      width 240px
      margin-right 10px
      &>img 
        width 100%
  .footer
    position fixed
    bottom 0
    left 0
    right 0
    display flex
    height 54px
    border-top: 1px solid #f0f0f0;
    .footerLeft
      width 70%
      display flex
      align-items center
      justify-content flex-end
      padding-right 10px
      box-sizing border-box
    .footerRight
      width 30%
      display flex
      align-items center
      justify-content center
      background #c21a1a
      color #fff
  

</style>



// WEBPACK FOOTER //
// src/pages/Together/TogetherOrder.vue